import { render, staticRenderFns } from "./VehiclesUploadedTable.vue?vue&type=template&id=28e6e9f7&scoped=true&"
import script from "./VehiclesUploadedTable.vue?vue&type=script&lang=js&"
export * from "./VehiclesUploadedTable.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesUploadedTable.vue?vue&type=style&index=0&id=28e6e9f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6e9f7",
  null
  
)

export default component.exports